import React from 'react'
import styled from 'styled-components'

import { Logo } from '../../assets/Logo'
import { LanguageSwitcher } from '../../i18n/LanguageSwitcher'
import { FlexRow } from '../FlexboxReusables/FlexItems'

const AnonymousNavbar = () => {
  return (
    <NavbarContainer>
      <FlexRow>
        <FlexRow width='50%' justifyContent='flex-start'>
          <LogoContainer>
            <Logo />
            <CourseWareText>CourseWare</CourseWareText>
          </LogoContainer>
        </FlexRow>
        <FlexRow width='50%' justifyContent='flex-end' padding='0 1em 0 0'>
          <LanguageSwitcher />
        </FlexRow>
      </FlexRow>
    </NavbarContainer>
  )
}

export default AnonymousNavbar

const NavbarContainer = styled.div`
  height: 70px;
  width: 100vw;
  background-color: #f0f2f5;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-bottom: 2px solid #ddd;
`

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 10em;
`

const CourseWareText = styled.h1`
  font-size: 1.2em;
  margin-top: -0.5em;
  font-weight: bold;
  color: #14CCAA;
`